import React from "react";
import { motion } from "framer-motion";

const VideoCards = ({ cards, cardsPerRow = 3 }) => {
  // Map cardsPerRow to responsive widths
  const getCardWidth = () => {
    switch (cardsPerRow) {
      case 1:
        return "w-full";
      case 2:
        return "w-full sm:w-[48%]";
      case 3:
        return "w-full sm:w-[48%] md:w-[30%]";
      case 4:
        return "w-full sm:w-[48%] md:w-[23%]";
      default:
        return "w-full sm:w-[48%] md:w-[30%]";
    }
  };

  return (
    <div className="py-12 bg-black">
      <h2 className="bg-black text-4xl font-bold text-center text-white pb-8">
        X-tremetuning Services
      </h2>
      <div className="px-8 bg-black flex flex-wrap justify-center gap-6">
        {cards.map((card, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            className={`bg-[#BD0E0E] rounded-lg shadow-lg text-center p-6 transition-transform transform hover:scale-105 ${getCardWidth()} hover:shadow-[0px_0px_15px_5px_rgba(255,0,0,0.7)] hover:text-white`}
          >
            <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-4 bg-white flex items-center justify-center">
              <video
                className="w-full h-full object-cover"
                src={card.videoSrc}
                autoPlay
                loop
                muted
              ></video>
            </div>
            <h3 className="text-xl font-semibold text-white">{card.title}</h3>
            <p className="text-white text-sm mb-4">{card.description}</p>
            <a
              href={card.buttonLink}
              className="bg-white hover:bg-black text-black hover:text-white p-2 rounded-md"
            >
              Meer lezen
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default VideoCards;
